"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.increment = exports.failure = exports.success = exports.request = exports.saga = void 0;

var _reduxActions = require("redux-actions");

var types = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var saga = (0, _reduxActions.createAction)(types.SAGA, function (filterType, fieldName, optionsSource, abortController) {
  return {
    filterType: filterType,
    fieldName: fieldName,
    optionsSource: optionsSource,
    abortController: abortController
  };
});
exports.saga = saga;
var request = (0, _reduxActions.createAction)(types.REQUEST, function (filterType, fieldName) {
  return {
    filterType: filterType,
    fieldName: fieldName
  };
});
exports.request = request;
var success = (0, _reduxActions.createAction)(types.SUCCESS, function (filterType, fieldName) {
  return {
    filterType: filterType,
    fieldName: fieldName
  };
});
exports.success = success;
var failure = (0, _reduxActions.createAction)(types.FAILURE, function (filterType, fieldName) {
  return {
    filterType: filterType,
    fieldName: fieldName
  };
});
exports.failure = failure;
var increment = (0, _reduxActions.createAction)(types.INCREMENT, function (filterType, fieldName, disableValue) {
  return {
    filterType: filterType,
    fieldName: fieldName,
    disableValue: disableValue
  };
});
exports.increment = increment;